import nutCookies from "../../Assets/images/Products/Shop-7.webp";
import TMRice from "../../Assets/images/Products/Shop-8.webp";
import flowerMushroom from "../../Assets/images/Products/Shop-9.webp";
import potato from "../../Assets/images/Products/Shop-10.webp";
import freshMeat from "../../Assets/images/Products/Shop-11.webp";
import fishCurry from "../../Assets/images/Products/Shop-13.webp";


const SnacksData = [
    {
        id: 1218,
        title: "Nut Cookies",
        img: nutCookies,
        price: 50,
        rating: 5,
      },
      {
        id: 1219,
        title: "Tm Rice",
        img: TMRice,
        price: 80,
        rating: 4,
      },
      {
        id: 1220,
        title: "Mushroom",
        img: flowerMushroom,
        price: 60,
        rating: 3,
      },
      {
        id: 1221,
        title: "Potato",
        img: potato,
        price: 50,
        rating: 4,
      },
    
      {
        id: 1222,
        title: "Fresh Meat",
        img: freshMeat,
        price: 400,
        rating: 3,
      },
      {
        id: 1223,
        title: "Fish Curry",
        img: fishCurry,
        price: 120,
        rating: 5,
      },
    ];

    export default SnacksData;